module.exports = {
      id: "longrightarrow-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#longrightarrow",
      toString: function () {
        return this.url;
      }
    }